import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for `/libraries/design-packages/*`.
 *
 * Optional `:productTliId?` segments use plain path strings (same pattern as `projectsPaths`).
 */
export const designPackagesRoute = defineRoute("/libraries/design-packages");
export const designPackageRoute = defineRoute("/libraries/design-packages/:designPackageId/:designPackageVersionId");
export const designPackageFinishScheduleRoute = defineRoute(
  "/libraries/design-packages/:designPackageId/:designPackageVersionId/finish-schedule",
);
export const designPackageCompareModeRoute = defineRoute(
  "/libraries/design-packages/:designPackageId/:designPackageVersionId/compare-mode",
);
export const designPackageAddToSlotRoute = defineRoute(
  "/libraries/design-packages/:designPackageId/:designPackageVersionId/add-to",
);
export const designPackageVersionHistoryRoute = defineRoute(
  "/libraries/design-packages/:designPackageId/:designPackageVersionId/history",
);
export const designPackagePersonalizationGroupsRoute = defineRoute(
  "/libraries/design-packages/:designPackageId/:designPackageVersionId/personalization-groups",
);
export const designPackageEditOptionRoute = defineRoute(
  "/libraries/design-packages/:designPackageId/:designPackageVersionId/options/:idOrAdd",
);
export const designPackageRequiredOptionsRoute = defineRoute(
  "/libraries/design-packages/:designPackageId/:designPackageVersionId/required-options",
);

/** Optional `:productTliId?` — not a `defineRoute`. */
export const designPackageProductCardPath =
  "/libraries/design-packages/:designPackageId/:designPackageVersionId/detail/:placeholderTliId/:productTliId?";
export const designPackageProductSearchPath =
  "/libraries/design-packages/:designPackageId/:designPackageVersionId/search/:placeholderTliId/:productTliId?";
export const designPackageAddProductPath =
  "/libraries/design-packages/:designPackageId/:designPackageVersionId/add-product/:placeholderTliId/:productTliId?";
